import { useState, useEffect } from 'react';
import { EVENTS } from '@trip-ux/constants';

export const useMedia = (queries, values, defaultValue) => {
  const match = () => {
    let query;
    if (typeof window !== 'undefined') {
      query = queries.findIndex(q => window.matchMedia(q).matches);
    }

    return values[query] || defaultValue;
  };

  const [value, set] = useState(match);
  useEffect(() => {
    const handler = () => set(match);
    window.addEventListener(EVENTS.RESIZE, handler);
    return () => window.removeEventListener(EVENTS.RESIZE, handler);
  }, []);

  return value;
};
